module.exports = __webpack_public_path__ + "static/media/bad-luck.5ba44702.gif";